import Vue from 'vue'
import moment from 'moment'
import VueMoment from 'vue-moment'

let lang = navigator.language || navigator.userLanguage
if (lang.match(/\w{2}-\w{2}/)) {
  lang = lang.split('-')[0].toLowerCase()
} else if (lang.match(/\w{2}/)) {
  lang = lang.toLowerCase()
}

Vue.config.languages = [
  {
    code: 'en',
    name: 'English'
  },
  {
    code: 'nl',
    name: 'Dutch'
  },
  {
    code: 'de',
    name: 'German'
  },
  {
    code: 'fr',
    name: 'French'
  }
]
Vue.config.defaultLanguage = 'en'

Vue.config.locale = lang
moment.locale(lang)
moment.updateLocale(moment.locale(), { invalidDate: '' })
Vue.use(VueMoment, {
  moment
})

console.log(moment.localeData())

Vue.config.localizedFormat = {
  date: moment.localeData()['_longDateFormat']['L'],
  longDate: moment.localeData()['_longDateFormat']['LL'],
  fullDate: moment.localeData()['_longDateFormat']['LLL']
}

Vue.filter('formatID', function (value) {
  if (!value) {
    return ''
  }
  value = value.toString()
  while (value.length < 6) {
    value = '0' + value
  }
  return value
})
